import { render, staticRenderFns } from "./DesignMore.vue?vue&type=template&id=1326ce27&scoped=true&"
import script from "./DesignMore.vue?vue&type=script&lang=js&"
export * from "./DesignMore.vue?vue&type=script&lang=js&"
import style0 from "./DesignMore.vue?vue&type=style&index=0&id=1326ce27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1326ce27",
  null
  
)

component.options.__file = "DesignMore.vue"
export default component.exports